<template>
<v-dialog
    v-model="dialog"
    max-width="1200"
>
    <v-card>
        <v-card-title>API Integration Instructions</v-card-title>

        <v-card-text>

            <p>You can grant or deny consent via RESTful api call.  To do so, simply POST the JSON shape below to {{$rc.getAPIEndpoint('',false)}}/consent/via-integration/{{$route.params.organization_id}}.</p>

            <p>Here is an example cURL command that grants conversational consent for an example customer:</p>

            <m-code-block
                :click_anywhere_to_copy="false"
        >
curl -v -X POST {{$rc.getAPIEndpoint('',false)}}consent/via-integration/{{$route.params.organization_id}}  \<br/>
-H 'Content-Type: application/json; charset=utf-8' \<br/>
--data-binary @- &lt;&lt; EOF<br/>
{<br/>
   "full_name" : "Jane Doe",<br/>
   "first_name" : "Jane",<br/>
   "last_name" : "Doe",<br/>
   "mobile": "237-111-2222",<br/>

   "consent_specimen": "This is an example agreement -- do not use in production",<br/>
   "consent_conversational": true,<br/>
   "consent_informational": false,<br/>
   "consent_promotional": false<br/>
}<br/>
EOF        <br/>
        </m-code-block>

        <p>When you test, it is a best practice to use phone numbers with the area code <code>237</code>.  There are no (actual) 237 area code numbers so you are guaranteed to conflict with actual customers</p>

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>